var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: _vm.linkClass,
      attrs: { href: "#" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.goToHelp()
        }
      }
    },
    [
      _c("font-awesome-icon", { attrs: { icon: "question-circle" } }),
      _vm._v(" "),
      _vm.disableText
        ? _c("span", { staticClass: "visible-lg-inline" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.$t("MAIN_CONTENT.HelpButton.helpLink")) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.modalTitle,
            show: _vm.showModal,
            "dialog-size": "md",
            name: "helpResourceModalBlocked"
          },
          on: {
            close: function($event) {
              return _vm.closeModal()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(modalProps) {
                return [
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.HelpButton.popupBlocked")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.HelpButton.clickLinkMessage")
                        ) +
                        "\n\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.helpData.HELP_LINK,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("MAIN_CONTENT.HelpButton.goToHelp")) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.HelpButton.note")))
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-transparent pull-right",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")) +
                    "\n\t\t\t"
                )
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }